export enum ServiceActive {
  Active = '1',
  NotActive = '0',
}
